module.exports = __webpack_public_path__ + "static/img/5.94912e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/5.png
// module id = QrnE
// module chunks = 0